import sileo from 'sileo';

const JobOfferApplicantDetails = new sileo.Model('bposeats', 'job-offer-applicant-details');
const JobOffer = new sileo.Model('bposeats', 'job-offer');
const JobOfferCreate = new sileo.Model('bposeats', 'job-offer-create');
const JobOfferUpdate = new sileo.Model('bposeats', 'job-offer-update');
const JobOfferDetailsUpdate = new sileo.Model('bposeats', 'job-offer-details-update');
const JobOfferNegotiation = new sileo.Model('bposeats', 'job-offer-negotiation');
const JobPostingMessage = new sileo.Model('hqzen', 'job-posting-message');
const JobPostingMessageThread = new sileo.Model('hqzen', 'job-posting-message-thread');
const JobOfferRotation = new sileo.Model('bposeats', 'job-offer-rotation');
const JobOfferRotationSelectedApplicant = new sileo.Model('bposeats', 'job-offer-applicant-preferences');
const ApplicantInformation = new sileo.Model('bposeats', 'applicant');
const ApplicantSettings = new sileo.Model('applybpo', 'applicant-settings');
const JobPostingApplications = new sileo.Model('hqzen', 'job-posting-applications');
const ApplicantJobOfferNegotiation = new sileo.Model('hqzen', 'job-offer-negotiation');
const ApplicantJobOffer = new sileo.Model('hqzen', 'job-offer');
const ApplicantJobOfferDetails = new sileo.Model('hqzen', 'job-offer-details');
const ApplicantJobOfferContracts = new sileo.Model('hqzen', 'job-offer-contracts');
const ApplicantJobOfferArchive = new sileo.Model('bposeats', 'job-offer-archive');
const JobApplicationSection = new sileo.Model('bposeats', 'job-applications-section');
const RejectionReasons = new sileo.Model('bposeats', 'workforce-rejection-reasons');
const MinimalJobOffer = new sileo.Model('hqzen', 'job-offer-minimal');
const NegotiatingJobOffer = new sileo.Model('hqzen', 'negotiating-job-offers');
const CompanyHandbook = new sileo.Model('applybpo', 'company-handbook-seen');
const Employment = new sileo.Model('applybpo', 'employments');
const ContractContentUpdate = new sileo.Model('hqzen', 'applicant-update-contract-content');
const MessageThreads = new sileo.Model('hqzen', 'job-posting-with-inquiry');
const PendingMessageThreads = new sileo.Model('hqzen', 'fetch-threads-with-pending-messages');
const MessageThreadStatusUpdateResource = new sileo.Model('hqzen', 'update-message-thread-status');
const MessageAttachmentAmazonCredentials = new sileo.Model('hqzen', 'job-posting-amazon-form-data');
const JobPostingMessageAttachment = new sileo.Model('hqzen', 'job-posting-attachment-creation');
const JobOfferUpdateOnHold = new sileo.Model('bposeats', 'job-offer-on-hold');
const PlatformSettingsTemplates = new sileo.Model('hqzen', 'platform-settings-template-list');
const JobOfferAmazon = new sileo.Model('bposeats', 'job-offer-amazon-form-data');
const JobOfferStartDateChangeRequest = new sileo.Model('hqzen', 'job-offer-start-date-change-request');
const RecruitmentStaffConfiguration = new sileo.Model('hqzen', 'recruitment-staff-configurations-template');
const MessageThreadAttachments = new sileo.Model('hqzen', 'message-thread-attachments');
const EvaluateApplicantJobOfferProgress = new sileo.Model('hqzen', 'evaluate-applicant-job-offer-progress');

const state = {
    sendJobOfferHistory: {
        employment: null,
        contract_policy: null,
        contracts: []
    },

    sendJobOfferRequestHistory: {
        employmentDetails: null,
        contractPolicy: null,
        contracts: [],
        benefits: null
    }
};

const getters = {
    sendJobOfferHistory: (state) => {
        return state.sendJobOfferHistory;
    },

    sendJobOfferRequestHistory: (state) => {
        return state.sendJobOfferRequestHistory;
    }
};

const mutations = {
    setJobOfferEmployment(state, payload) {
        state.sendJobOfferHistory.employment = payload;
    },

    setJobOfferContractPolicy(state, payload) {
        state.sendJobOfferHistory.contract_policy = payload;
    },

    setJobOfferContracts(state, payload) {
        state.sendJobOfferHistory.contracts = payload;
    },

    resetJobOfferDetails(state, payload) {
        state.sendJobOfferHistory = {
            employment: null,
            contract_policy: null,
            contracts: []
        };
    },

    setJobOfferContractsToUpdate (state, payload) {
        state.sendJobOfferHistory.contracts_to_update = payload;
    },

    setJobOfferRequestEmploymentDetails(state, payload) {
        state.sendJobOfferRequestHistory.employmentDetails = payload;
    },

    setJobOfferRequestContractPolicy(state, payload) {
        state.sendJobOfferRequestHistory.contractPolicy = payload;
    },

    setJobOfferRequestContracts(state, payload) {
        state.sendJobOfferRequestHistory.contracts = payload;
    },

    setJobOfferRequestBenefits(state, payload) {
        state.sendJobOfferRequestHistory.benefits = payload;
    },

    resetJobOfferRequestDetails(state, payload) {
        state.sendJobOfferRequestHistory = {
            employmentDetails: null,
            contractPolicy: null,
            contracts: [],
            benefits: null
        };
    }

};

const actions = {
    fetchRejectionReasons(context, filters) {
        return RejectionReasons.objects.filter(filters);
    },

    fetchPlatformSettingsTemplates(context, filters) {
        return PlatformSettingsTemplates.objects.filter(filters);
    },

    fetchMessageThreads(context, filters) {
        return JobPostingMessageThread.objects.filter(filters);
    },

    getMessageThread(context, pk) {
        return JobPostingMessageThread.objects.get(pk);
    },

    fetchJobOffers(context, filter) {
        return MinimalJobOffer.objects.filter(filter);
    },

    getJobOffer(context, pk) {
        return MinimalJobOffer.objects.get(pk);
    },

    fetchContracts(context, filter) {
        return JobOfferContracts.objects.filter(filter);
    },

    fetchNegotiatingJobOffers(context, filter) {
        return NegotiatingJobOffer.objects.filter() ;
    },

    getNegotiatingJobOffer(context, pk) {
        return NegotiatingJobOffer.objects.get(pk);
    },

    getJobOfferApplicantDetails(context, pk) {
        return JobOfferApplicantDetails.objects.get(pk);
    },

    fetchJobOfferApplicantDetails(context, filter) {
        return JobOfferApplicantDetails.objects.filter(filter);
    },

    async fetchJobOfferAmazonFormData(context) {
        return await JobOfferAmazon.objects.filter().then(data => {
            return data.amazon;
        });
    },

    fetchRecruitmentStaffConfigurationTemplate(context, filter) {
        return RecruitmentStaffConfiguration.objects.filter(filter);
    },

    createJobOffer({ commit }, jobOffer) {
        const form = new FormData();

        Object.keys(jobOffer).forEach(key => form.append(key, jobOffer[key]));

        return JobOfferCreate.objects.create(form);
    },

    updateJobOfferDetails({ commit }, jobOffer) {
        const form = new FormData();
        Object.keys(jobOffer).forEach(key => form.append(key, jobOffer[key]));

        return JobOfferDetailsUpdate.objects.update({ pk: jobOffer.pk }, form);
    },

    fetchJobOfferById(context, pk) {
        return JobOffer.objects.get(pk);
    },

    fetchNegotiationsOfJobOffer(context, pk) {
        return JobOfferNegotiation.objects.filter({ job_offer__pk: pk });
    },

    updateNegotiationSeen(context, pks) {
        if (pks && pks.length) {
            let form = new FormData();
            form.append('negotiation_pks', pks);
            JobOfferNegotiation.objects.update({}, form);
        }
    },

    fetchMessagesThreads(context, filter) {
        return MessageThreads.objects.filter(filter);
    },

    getMessageThread(context, pk) {
        return MessageThreads.objects.get(pk);
    },


    fetchUnreadChats(context, filter) {
        return PendingMessageThreads.objects.filter(filter);
    },

    fetchMessagesList(context, filter) {
        return JobPostingMessage.objects.filter(filter);
    },

    fetchMessageThreadAttachments(context, filter) {
        return MessageThreadAttachments.objects.filter(filter);
    },

    // This method facilitates the creation of a
    // JobOfferNegotiation and/or a standard Message
    sendCounterMessage(context, data) {
        const form = new FormData();

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });
        return JobPostingMessage.objects.create(form);
    },

    fetchJobOfferByForeignKeys(context, keys) {
        return JobOffer.objects.filter(keys);
    },

    cancelJobOffer(context, data) {
        const form = new FormData();

        const { pk } = data;
        delete data['pk'];

        form.append('status', data.status);

        if (data.remarks) {
            form.append('remarks', data.remarks);
        }

        return JobOfferUpdate.objects.update({ pk: pk }, form);
    },

    fetchJobOfferRotationApplicants(context, filters) {
        return JobOfferRotation.objects.filter(filters);
    },

    fetchJobOfferRotationSelectedApplicant(context, filters) {
        return JobOfferRotationSelectedApplicant.objects.filter(filters);
    },

    getApplicantInformation(context, pk) {
        return ApplicantInformation.objects.get(pk);
    },

    fetchApplicantSettingsData(context) {
        return ApplicantSettings.objects.filter();
    },

    fetchJobPostingApplications(context, filters) {
        return JobPostingApplications.objects.filter(filters);
    },

    getJobPostingApplication(context, pk) {
        return JobPostingApplications.objects.get(pk);
    },

    fetchJobOfferNegotiations(context, jobOfferPk) {
        return ApplicantJobOfferNegotiation.objects.filter({ job_offer__pk: jobOfferPk });
    },

    updateJobOfferNegotiationSeen(context, pks) {
        if (pks && pks.length) {
            let form = new FormData();
            form.append('negotiation_pks', pks);
            ApplicantJobOfferNegotiation.objects.update({}, form);
        }
    },

    getApplicantJobOffer(context, pk) {
        return ApplicantJobOffer.objects.get(pk);
    },

    getApplicantJobOfferDetails(context, pk) {
        return ApplicantJobOfferDetails.objects.get(pk);
    },

    fetchApplicantJobOfferContracts(context, filters) {
        return ApplicantJobOfferContracts.objects.filter(filters);
    },

    updateJobOfferDesiredStartDate(context, data) {
        const form = new FormData();

        const { pk } = data;
        delete data['pk'];

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return JobOfferStartDateChangeRequest.objects.update({ pk: pk }, form);
    },

    updateJobOfferOnHold(context, data) {
        const form = new FormData();

        form.append('is_on_hold', data.is_on_hold);
        form.append('job_offer_edited', data.job_offer_edited);

        return JobOfferUpdateOnHold.objects.update({ 'pk': data.pk }, form);
    },

    updateApplicantJobOffer(context, data) {
        const form = new FormData();

        const JOB_OFFER = {
            accepted: 1,
            declined: 2,
            cancelled: 3
        };

        form.append('status', JOB_OFFER[data.status]);
        form.append('remarks', data.remarks);
        form.append('decline_other_offers', data.decline_other_offers);
        form.append('decline_other_offers_remarks', data.decline_other_offers_remarks);

        return ApplicantJobOffer.objects.update({ 'id': data.job_offer_id }, form);
    },

    updateApplicantJobOfferArchive(context, data) {
        const form = new FormData();

        form.append('is_archived', data.is_archived);

        return ApplicantJobOfferArchive.objects.update({ 'pk': data.pk }, form);
    },

    updateApplicantJobApplicantArchive(context, data) {
        const form = new FormData();

        form.append('pk', data.pk);
        form.append('status', data.status);
        form.append('method', data.method);

        return JobApplicationSection.objects.update({}, form);
    },

    markHandbookSlideSeen(context, data) {
        const form = new FormData();

        let pk = data.pk,
            dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });

        return CompanyHandbook.objects.update({ 'pk': pk }, form);
    },

    setEmploymentToActive(context, data) {
        return new Promise((resolve, reject) => {
            data.signature.save(async(blob) => {
                const formData = new FormData();
                formData.append('job_offer_pk', data.job_offer_pk);
                formData.append('location', data.location);
                formData.append('signature', blob);
                resolve(await Employment.objects.create(formData));
            });
        });
    },

    applicantUpdateContractContent(context, data) {
        const form = new FormData();
        form.append('contracts', data.contracts);
        return ContractContentUpdate.objects.update({}, form);
    },

    updateApplicantContract(context, data) {
        const formData = new FormData();
        formData.append('contract_fields', data.contract_fields);
        formData.append('action', data.action);
        return ApplicantJobOfferContracts.objects.update({ pk: data.pk }, formData);
    },

    signContract(context, data) {
        const { pk, signature, ...restData } = data;
        const formData = new FormData();

        return new Promise((resolve) => {
            signature.save(async(blob) => {
                formData.append('signature', blob);
                formData.append('location', restData.location);
                formData.append('action', restData.action);
                resolve(await ApplicantJobOfferContracts.objects.update({ pk }, formData));
            });
        });
    },

    updateMessageThread(context, data) {
        const form = new FormData();
        form.append('seen', data.seen);
        form.append('read', data.read);
        form.append('latest_message_read', data.lastMessageRead);
        return MessageThreadStatusUpdateResource.objects.update({ pk: data.pk }, form);
    },

    async fetchMessageAttachmentAmazonFormData(context, filters) {
        return await MessageAttachmentAmazonCredentials.objects.filter(filters).then(amazon => {
            return amazon.amazon;
        });
    },

    createMessageAttachment(context, data) {
        const form = new FormData();

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return JobPostingMessageAttachment.objects.create(form);
    },

    evaluateApplicantJobOfferProgress(context, filters) {
        return EvaluateApplicantJobOfferProgress.objects.filter(filters);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
